import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

const locomotivePath = 'assets/locomotive.svg';

@Component({
  selector: 'app-train-wagon',
  templateUrl: './train-wagon.component.html',
  styleUrls: ['./train-wagon.component.scss']
})
export class TrainWagonComponent implements OnInit {
  @Input() wagonData: any;
  @Input() index: number;
  @Input() isLastWagon: boolean;
  @Output() addEvent: EventEmitter<number> = new EventEmitter();
  @Output() deleteEvent: EventEmitter<any> = new EventEmitter();
  @Output() swapPlacesEvent: EventEmitter<number> = new EventEmitter();
  @Output() rotateEvent: EventEmitter<any> = new EventEmitter();
  @Output() editEvent: EventEmitter<any> = new EventEmitter();
  imageSrc: string | ArrayBuffer | null = null;
  constructor() { }

  ngOnInit() {
    this.imageSrc = undefined;
    if (this.wagonData.variantId && this.wagonData.image || this.wagonData.variantId && this.wagonData.image == "") {
      this.imageSrc = 'data:image/png;base64,' + this.wagonData.image;
    }
    else if (this.wagonData.variantId == null) {
      this.imageSrc = locomotivePath;
    }
  }
  add() {
    this.addEvent.emit(this.index);
  }
  delete() {
    this.deleteEvent.emit(this.wagonData.id);
  }
  swapPlaces() {
    this.swapPlacesEvent.emit(this.index);
  }
  rotate() {
    this.rotateEvent.emit(this.wagonData.id);
  }
  edit() {
    this.editEvent.emit(this.wagonData);
  }
}
